// src/api/apiConfig.js — re-exports from central constants for AuthContext / admin modules
import { API_BASE_URL, API_CONFIG as CENTRAL_API_CONFIG } from "../config/constants";

export const API_CONFIG = {
  ...CENTRAL_API_CONFIG,
  baseURL: API_BASE_URL,
};
